export default {
	logoName:'OYUAPP',
	comboChooseText:'--Таңдау--',
	save :"Сақтау",
	reset:"Қалпына келтіру",
	logOut:'Жүйеден шығу',
	oyu:{
		landing:{
			noSub:"you don't have an active subscription.",
			activeSub:"You  have an  active subscription.",
			changePassDesc:"Reset your password by email",
			sendingCode:"continue",
			recoverCode:"The 4-digit code which will be sent to your email",
			newPass:"New password",
			newPassRe:"Repeat new password",
			signCount:"Password length must be more than 4 sign",
			passChanged:"Password successfully changed",
			wrongCode:"Incorrect code",
			notSame:"Passwords are not matched",
			errorTitle:"Error",
			changePassword:"change password",
			moreSign:"password should contain more than 4 sign",
			noUser:"Email not registered",
			
			catTitle:"Categories",
			passChar:"Password should contain more than 4 sign",
			notSame:"Passwords are not matched",
			wrongLog:"Email or password is incorrect",
			copyright:"© 2023 OYU App. All rights reserved.",
			register:"sign-up",
			search:"search",
			login:"sign-in",
			acc:{
				title:"account",
				choosen:"chosen ornaments",
				logout:"sign-out",

				private:"personal information",
				sub:"your subscription",
				manageSub:"manage subscription",
				download:"download"
			},
			chooseProduct: "Choose your\nornament!",
			chooseP: "Choose",
			slideDesc1:"get access to more than 700 ornaments collections in 13 categories",
			subscribe : "Subscribe",		
			loginTitle: "Welcome to the OYU app!",
			loginSubTitle: "choose your sign-in method",

			email:"your email",
			signName: "your name",
			password:"password",
			rePassword:"repeat password",
			login:"sign in",
			freeReg:"sign-up for free",
			regFree:"sign-up for free",
			signUp: "sign-up",
			forgotPassword:"forgot your password ?",
			registered:"The email has already registered.",
			regSuccess: "You have successfully registered.",
			operation: "You must be logged in to perform this action.",
			firstQuestion: "Which of the following would give you a special feeling ?",
			privateOrnament: "your own ornament",
			ornaments: "ornaments",
			allCats: "all",
			fileType:"file type",
			download:"Download",
			backOrnaments:"return to ornaments",

			bookText:"more than 700 ornaments collections",
			authorText:"“I'm not aware of any previous complete collection of Kazakh ornaments that is as thorough as this”.",
			authorName:"Erlan Karin",
			buyText:"buy",
			buy1:"Meloman",
			buy2:"Marwin",
			downloadText1:"Сонымен қатар, қосымша бизнес үшін де, жеке қызығушылықтарға қолдану үшін де қолжетімді",
			downloadText2:"қосымшаның көмегімен арнайы сұрақтарға жауап беру арқылы өз оюыңызды таңдай аласыз.",

			aboutApp: "about the site",
			usageTerm:"terms of use",
			policy:"privacy policy",
			paymentProc:"payment procedure",
			appIntro: "OYU app is a website that provides full-fledged visual information about ornaments, an important fragment of Kazakh culture, and allows to properly arrange and develop their use in different areas.<br><br> In this website , you will find a collection of more than 700 unique ornaments in 13 categories. The website is created for a wide community of professional designers and the general public.",
		},

		qGroup:{
			qGroup:"Сұрақтар тобы",
			groupNameKz:"Топтың аты kz",
			groupNameRu:"Топтың аты Ru",
			groupNameEn:"Топтың аты En",
		},
		question:{
			question:"Сұрақ",
			questionRu:"Сұрақ Ru",
			questionEn:"Сұрақ En",
			answers:"Жауаптар",
			createQuestion:"Сұрақ құру"
		},
		oyuCat:{
			catName:"Санат",
			catNameRu:"Санат ru",
			catNameEn:"Санат en",			
			catIcon:"ICON",			
			productCount:"Оюулар саны",	
			createOyuCat:"Санат құру"		
		},
		oyuProduct:{
			productName:"Аты Kz",
			productNameRu:"Аты Ru",
			productNameEn:"Аты En",
			image:"Сурет",
			catNames:"Санаттар",
			description:"Сипаттама",
			createOyuProduct:"Жазба қосу",
			addToAnswer:"Жауапқа Оюулар қосу"
		},
		interval:{
			intervalName:"Интервал атауы",
			beginPoint:"Басталуы",
			endPoint:"Аяқталу",
			addProduct:"Элементті қосу",
			isActive:"Белсенді",
			productCount:"Оюу саны",
			addProduct:"Оюу қосу"
		}
	},
	system:{
		errorTitle:'Error',
		successTitle:'Жетістік',
		successMsg:"Сәтті аяқталды",
		dublicationMsg:'Жазба қайталанған !!!',
		newRecord:"Жаңа жазба",
		confirmMsg:'Сіз сенімдісіз бе ?',
		selectAll:'Барлығын таңдаңыз',
		unSelectAll:'Барлығын алып тастау',
		status:'Статус',
		beginDate:"Басталу күні",
		endDate:"Аяқталу күні",
		search:"Search",
		loading:"Жүктелуде",
		add:'қосу',
		delete:'жою',
		update:'жаңарту',
		failMsg:"Белгісіз қате анықталды. Қайталап көріңіз.",
		delete:"Жою",
		update:"Жаңарту",
		actions:"Әрекеттер"
	},

	mainMenu: {
		
		currentLang:'КАЗ',
		users: 'Қолданушылар',
		courseAndModule :"Курс && Модуль",
		lecture:"Лекция",
		lab:"Лаборатория",
		server :"Серверді басқару",
		test:"Тест",
		video:"Видео"
	},
	lMenu:{
		courses:"курстар",
		freeCourses:"тегін курстар",
		start:"бастау"
	},
	lms:{
		machineTurnOnError:"an error occured when turning on machines"
	},
	
	deliveryList:{
		deliveryListTitle:"Тапсырыстар тізімі",
		newDelivery: "Жаңа",
		inProgress:"Орындалуда",
		done:"Дайын",
		deepSearch:"Терең іздеу",
		cassReport:"Касс есебі",
		byOrderNumber:"Тапсырыс нөмірі бойынша",
		byNewOrder:"Жаңа тапсырыс бойынша",
		

	},
	orderDate:"Тапсырыс күні",
	orderNumber:"Тапсырыс нөмірі",
	userInfo:"Клиент туралы ақпарат",
	totalProductPrice:"Өнімнің жалпы бағасы",
	takenCostByCash:"Қолма-қол ақшамен",
	takenCostByCard:"Карта арқылы",
	deliveryLoan:"Тапсырыс несиесі",
	showDetails:"Мәліметтерді көрсету",
	updateOrder:"Тапсырысты жаңарту",
	deleteOrder:"Тапсырысты жою",
	noSlicers:"Кесушiлер тандамаган",
	catName:"Өнім санаты",
	colorName:"Өнімнің түсі",
	measureName:"Өлшемі",
	productCount:"Өнім саны",
	doneCount:"Аяқталған саны",
	leftCount:"Аяқталмаған саны",
	productPrice:'Өнімнің бағасы',
	totalPrice:"Жалпы бағасы",
	wareHouseName:"Қойма",
	
	listSlicers:"Кесушілер",
	completed:"Аяқталды",
	unCompleted:"Аяқталмаған",
	orderActions:"Әрекеттер",
	teacherModule:{
		myDocuments : 'Менің құжаттарым',
		newDocument : 'Жаңа құжатты толтыру'
	},
	userPage :{
		userList:'Қолданушылар тізімі'
	},
	wrongFile:"Жүктелуі тиіс файлдың атын ауыстыруыңызды сұраймыз. Файл атауында нүкте немесе с.с. арнайы символдар болмауы тиіс!!!",
	
	lms:{
		login:"Жүйеге кіру",
		register:"Жүйеге тіркелу",
		userList:{
			systemUsers:'Жүйе пайдаланушылары',
			firstName:'Аты',
			lastName:'Тек',
			userName:'Логин аты',
			phoneNumber:'Телефон нөмірі',
			role :'Жүйедегі рөлі',
			blocking:"Блоктау",
			unblocking:"Блоктан шығару",
			enroll:"Тіркелу"
		},
		
		userForm:{
			modalTitle:"Пайдаланушы ақпараты",
			userType:"Пайдаланушы түрі",
			thirdName:"Әкесінің аты",
			lastName:"Тек",
			firstName:"Аты",
			phoneNumber:"Телефон нөмірі",
			email:"Электрондық пошта",
			password:"Құпия сөз",
			repeatPassword:"Құпия сөзді қайталаңыз",
			addUser:"Пайдаланушы қосу",
			clear:"Тазалау",
			roleConfirm:"Пайдаланушы түрін таңдау керек",
			passwordsNotMatchError:"Сіз енгізген құпия сөздер бірдей емес!!!",
			dublicatedEmail:"Электрондық пошта бұрыннан тіркелген!!!",
			wrongLogin:"Электрондық пошта немесе құпия сөз дұрыс емес.",
			blockedUser:"Сіз блокталған пайдаланушысыз. Жүйе әкімшісіне хабарласыңыз"
		},
		
		
		courseList:{
			mainTitle:"Курс пен модульді басқару",
			courseList:"Курс тізімі",
			courseName:"Аты",
			moduleCount:"Модульдер",
			courseCount:"Курстар",
			studentCount:"Студенттер",
			status:"Күй",
			delete:"Жою",
			active:"Белсенді",
			inActive:"Белсенді емес",
			newCourse:"Жаңа курс [+]",
			moduleName:"Модуль",
			lectureCount:"Лекция",
			labCount:"Лабротория",

			//new things
			yes:"Иә",
			no:"Жоқ",
			isFree:"Курс тегін бе, жоқ па",
			description:"Сипаттама",
			delete:"жою",
			introduction:"Курсқа кіріспе",
			isDefault:"Негізгі,негізгі емес",
			buildIntro:"Курстың кіріспесін құрастыру"

			
		},
		courseForm:{
			chooseFile:"Файлды таңдаңыз ...",
			dropFile:"Файлды осы жерге тастаңыз..."
		},

		moduleList:{
			moduleFiles:"Модуль бөліктері",
			create:"Модуль бөліктерін құрастыру",
			createModule:"Модуль жасау"
		},
		moduleForm:{
			modalTitle:"Курсты құру және жаңарту",
			chooseCourses:"Модульді қамтитын курстарды таңдаңыз"
		},
		serverList:{
			mainTitle:"Лабротория құруға арналған серверлер",
			serverName:"Сервер атауы",
			ipAddress:"Сервер IP",
			description:"Сипаттама",
			imagePath:"Логотип",
			createServer:"Сервер құру",
			userName:"Сервер пайдаланушы аты",
			password:"Сервер құпия сөзі",
			protocol:"Сервер протоколы",
			hasPublicIp:"Серверде сыртқы IP бар ма ?",
			ami:"AMI",
			ipMask:"IPMASK",
			instanceType:"Instance type"
		},
		labList:{
			mainTitle:"Әр модуль үшін лаброториялар",
			chooseServers:"Лабротория үшін пайдаланылатын серверлерді таңдаңыз",
			labName:"Лабротория атауы",
			labText:"Лабротория сипаттама",
			labEmbedded:"Лабротория бейне сабақ",
			chooseScorm:"Лаброторияға арналған SCORM файлы",
			labFiles:"Қосылған бөліктер",
			createLab:"Лабротория құру",
			servers:"Серверлер",

			isLecture:"Лекция ма, жоқ па?",
			lectureList:"Лекциялар",
			createLecture:"Дәріс құру",
			lectureName:"Лекция атауы",
			lectureText:"Лекция сипаттама",
			addToModule:"Модульге қосу"

		},
		videoList:{
			mainTitle:"Бейне тізімі",
			name:"Аты",
			description:"Сипаттама",
			showVideo:"Көру",
			videoPath:"Бейне коды",
			bottomText:"Бейнероликтің кіріспе мәтіні",
			createVideo:"Жаңа бейне жасау"
		},
		catList:{
			createCat:"Санат жасау",
			catName : "Санат атауы"
		},
		add:"Жазба қосу",
		clear:"Тазалау",
		chooseImage:"Суретті таңдаңыз.",
		detailSuccess:"Компонент сәтті жасалды.",
		image:"Фото компонент",
		scorm:"Scorm компоненті",
		video:"Бейне компоненті",
		text:"Мәтіндік компонент",
		command:"Code, command",
		detailComps:"Құрамдас бөліктер",
		courseCategory:"Курс санаты [+]",
		chooseCats:"Санаттарды таңдаңыз",
		isDefault:"Лекция негізгі бола ма?",
		vps:{
			manageVps:"VPS басқару",
			vpsName:"VPS атауы",
			manageVps:"Server vpses",
			chooseVpses:"VPS таңдаңыз"
		},
		myCourses:"Менің курстарым",
		mustLoginError:"Курсты көру үшін жүйеге кіру керек!!!",
		selectCourses:"Курстарды таңдау."
		
	}
};